
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web-not-available",
      function () {
        return require("private-next-pages/web-not-available.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/web-not-available"])
      });
    }
  